import { addHours } from "date-fns"
import { appStorage } from "./storage"

export const updater = <T extends (set?: any) => any, R = ReturnType<T>>(
  reactiveVar: T,
  ...callbacks: Array<(value: R) => Promise<R>>
): React.Dispatch<React.SetStateAction<R>> => {
  return async (f) => {
    let next = typeof f === "function" ? (f as any)(reactiveVar()) : f
    for (const cb of callbacks) {
      next = await cb(next)
    }
    reactiveVar(next)
    return next
  }
}
export const updateReactiveVarAndAddToLocalStorage = <T extends (set?: any) => any, R = ReturnType<T>>(
  reactiveVar: T, key: string,
): React.Dispatch<React.SetStateAction<R>> => {
  const updateAppStorage = async (val) => {
    await appStorage.set({ key: key, value: JSON.stringify(val) })
    return val
  }
  return async (f) => {
    let next = typeof f === "function" ? (f as any)(reactiveVar()) : f
    next = await updateAppStorage(next)
    reactiveVar(next)
    return next
  }
}

export const tryJsonParse = (v: string, defaultvalue: any) => {
  if (!v) {
    return defaultvalue
  }
  try {
    return JSON.parse(v)
  } catch (err) {
    console.error("failed to read parse json", v, err)
    return defaultvalue
  }
}

export function parseLocalStorageValueAndFilterOutOldIffContainsDate<T extends {date?: Date}>(value: string): Record<string, T> | null | undefined {
  const json = tryJsonParse(value, null) as Record<string, T>
  if (!json) {
    return
  }
  const now = new Date()
  const cutoff = addHours(now, -30).getTime()
  const reduced = Object.entries(json).reduce((r, [k, v]) => {
    if (v.date && new Date(v.date).getTime() < cutoff) {
      return r
    }
    return { ...r, [k]: v }
  }, {})
  return reduced
}